import { memo, useCallback } from 'react';
import { Tooltip } from '@material-ui/core';

import { Typography, Icon, Label } from '@components';
import { content } from '@content';
import { format } from '@utils';

import { SignalProps } from './Signal.props';
import { useStyles, useTooltipStyles } from './Signal.styles';
import { getStyle } from './Signal.utils';

/**
 Signal component
 @returns {JSX.Element}
 */

export const Signal = memo(
  ({ className, provided, item, style, isClicable, isDragging, onClick }: SignalProps): JSX.Element => {
    const styles = useStyles();
    const tooltipStyles = useTooltipStyles();

    const handleSignalClick = () => {
      if (onClick) {
        onClick(item);
      }
    };

    const getTooltipTitle = useCallback(() => {
      if (item.error) {
        return <span className={styles.errorText}>{content.error}</span>;
      }

      if (item.isUploading) {
        return <span className={styles.errorText}>{content.inProgress}</span>;
      }

      if (item.updatedAt) {
        if (item.signalType === 'foreign') {
          return format.date(item.updatedAt, 'MM/dd/yy');
        } else {
          return `${format.date(item.updatedAt, 'MM/dd/yy')} | ${item.type} | ${format.number(item.totalSubscribers)}`;
        }
      }
      return '';
    }, [
      item.error,
      item.isUploading,
      item.signalType,
      item.totalSubscribers,
      item.type,
      item.updatedAt,
      styles.errorText,
    ]);

    return (
      <Tooltip title={getTooltipTitle()} placement="bottom" arrow classes={tooltipStyles}>
        <div
          /* eslint-disable react/jsx-props-no-spreading */
          {...(provided ?? {}).draggableProps}
          {...(provided ?? {}).dragHandleProps}
          {...{ ref: (provided ?? {}).innerRef }}
          /* eslint-enable react/jsx-props-no-spreading */
          style={getStyle({ provided: provided ?? ({ draggableProps: { style: {} } } as any), style, isDragging })}
          className={`${styles.signal} ${styles.signalCapsule} ${className}`}
          onClick={handleSignalClick}
        >
          <div className={styles.leftContainer} style={{ cursor: isClicable ? 'pointer' : 'default' }}>
            <div className={styles.content}>
              <div className={styles.row}>
                <Typography.Caption
                  // title={item.label}
                  display="inline"
                  noWrap
                  component="div"
                  className={styles.signalText}
                >
                  {item.label}
                </Typography.Caption>
              </div>
            </div>
          </div>
        </div>
      </Tooltip>
    );
  },
);

Signal.displayName = 'Signal';
